module.exports = __webpack_public_path__ + "img/roll.ac50b74a.gif";